import { render } from "./offer.other.vue?vue&type=template&id=0344a672"
import script from "./offer.other.vue?vue&type=script&lang=js"
export * from "./offer.other.vue?vue&type=script&lang=js"

import "./offer.other.vue?vue&type=style&index=0&id=0344a672&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__